import React from 'react'

import MapComponent from '../../common/components/organisme/MapComponent/MapComponent'

export default function TestPage() {
  return (

        <MapComponent />


  )
}
